<template>
  <div>
    <div style="position: relative;">
      <div class="imgpost" style="z-index: 99;"   >


       <!-- <div @click="handleClick2(1)">回首页</div>  -->
    <el-image style="width: 120px; height: 48px" @click="handleClick2"
      :src="require('../../public/static/homeImg/logo.png')"
      fit="fit"></el-image>
  </div>
      <div style="text-align: center;">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="首页" name="first"> <PageOne></PageOne> </el-tab-pane>
    <!-- <el-tab-pane label="走进番茄站" disabled class="twoTitle" >走进番茄站</el-tab-pane> -->
    <el-tab-pane  disabled  @mouseover="showTitle"  >
    <span slot="label" @mouseover="isHovered = true" class="twoTitle" > 走进番茄站<i class="el-icon-arrow-down" style="font-size: 20px;margin-left: 3px;"></i></span>
    <!-- style="height: 100px;display: block;" @mouseleave="isHovered = false" -->
  </el-tab-pane>
    <el-tab-pane label="社会责任" name="third"> <pageThree></pageThree> </el-tab-pane>
    <el-tab-pane label="湾区动态" name="fourth"> <pageFourth></pageFourth> </el-tab-pane>
    <el-tab-pane label="联系我们" name="five"> <pageFive></pageFive> </el-tab-pane>

  </el-tabs>
</div>

<div class="titleMain" v-if="isHovered" @mouseleave="isHovered = false">
  <div class="title_item">
    <div @click="scrollTitle('section1')">公司概况</div>
    <div @click="scrollTitle('section2')">核心优势</div>
    <div @click="scrollTitle('section3')">行业影响力</div>
    <div @click="scrollTitle('section4')">获得荣誉</div>
    <div @click="scrollTitle('section5')">未来展望</div>
  </div>
</div>
</div>


</div>
</template>
<script>
import PageOne from '@/view/PageOne.vue'
import pageThree from '@/view/pageThree.vue'
import pageFourth from '@/view/pageFourth.vue'
import pageFive from '@/view/pageFive.vue'
import { EventBus } from './eventBus'





  export default {
    name: 'HeaderComponent',// 使用多词名称
    components: {
      PageOne,
      pageThree,
      pageFourth,
      pageFive

   
 
},
    data() {
      return {
        isHovered:false,
        activeName: 'first'
      };
    },
    created() {
    EventBus.$on('custom-event', this.handleEvent);
    EventBus.$on('scrollTop', this.scrollPage);
  },
  beforeDestroy() {
    EventBus.$off('custom-event', this.handleEvent);
  },
    methods: {
      scrollTitle(index){
        EventBus.$emit('scrollTop', { index: index });


      },
      showTitle(){
        this.isHovered=true

      },
      scrollPage(refName){
        console.log(refName,"传过来了锚点111");
        this.activeName='first'

      //   this.$nextTick(() => {
      //   const el = this.$refs[refName.index]
      //   el.scrollIntoView({ 
      //     behavior: 'smooth',
      //     block: 'start'  // 对齐到视口顶部
      //   })
      // })

      },
      handleEvent(payload) {
      console.log(payload.data,"传过来了");
      this.activeName=payload.data
      window.scrollTo({
  top: 0,
  behavior: 'smooth' // 平滑滚动效果
});

    },
      handleClick2(){
        console.log('999999',this.activeName)
        this.activeName='first'
        console.log('999999',this.activeName)
        window.scrollTo({
  top: 0,
  behavior: 'smooth' // 平滑滚动效果
});
      },
      handleClick(tab) {
        console.log(tab.index, "1111");
        window.scrollTo({
  top: 0,
  behavior: 'smooth' // 平滑滚动效果
});
//         if(tab.index==0){
// // 路径跳转
// this.$router.push('/PageOne.vue')
//         }
      }
    }
  };
</script>

<style scoped>
::v-deep .el-tabs__header{
  padding-top: 15px;
  position: sticky;
    top: 0px;
    z-index: 9999;
    background-color: #fff;
    z-index: 8;
}
::v-deep .el-tabs__nav-wrap::after{
  height: 0;
}
::v-deep .el-tabs__active-bar{
  height: 0;

}
::v-deep .el-tabs__nav {
    float: none;
}
::v-deep .el-tabs__item.is-disabled {
    color: #000000;
    cursor: default;
}
::v-deep .el-tabs__item.is-active {
  font-size: 16px;
  color: #FF2C27;
} 
::v-deep .el-tabs__item{
  font-size: 16px;

}
::v-deep .el-tabs__item:hover {
  color: #FF2C27;

}
.imgpost{
  position: fixed;
  left: 5px;
  top: 5px;
}

.titleMain{
  position: fixed;
    /* display: block; */
    width: 100%;
    top: 50px;
    z-index: 99;
    /* left: 40%; */
    text-align: center;
    background-color: #ffffff;
    padding: 10px 0;


}
.title_item{
  width: 100%;

  display: flex;
  justify-content: center;
}
.title_item div{
margin-right: 40px;
}
.titleMain:hover{
  cursor: pointer;
}
.title_item div:hover{
  color: #FF2C27;
}
</style>